export const API_BASE_URL = 'https://admin.xodesoftware.com';
export const SK = 'yz&$pb^Z+2uAFxd&Cdu9R6aBP^4N@M_B';

export const SUCCESS_COLOR = '#c6ad95';
export const FAILED_COLOR = '#d32f2f';
